import React, { useState } from "react";
import { Col } from "react-bootstrap";
import { MDBCollapse, MDBBtn, MDBIcon } from "mdb-react-ui-kit";

export const ProjectCard = ({ title, description, videoUrl, elements }) => {
  const [showShow, setShowShow] = useState(false);
  const [buttonText, setButtonText] = useState("See Course Elements");
  const toggleShow = () => {
    setShowShow(!showShow);
    setButtonText("Hide Course Elements");
    if (showShow) {
      setButtonText("See Course Elements");
    }
  };
  return (
    <Col size={12} sm={6} md={6}>
      <div className="animate__animated animate__slideInUp">
        <div className="proj-card">
          <video width="500" height="330" controls muted>
            <source src={videoUrl} type="video/mp4" />
          </video>
          <div className="proj-txtx">
            <h4>{title}</h4>

            <p>{description}</p>
          </div>
        </div>
      </div>
      <div>
        <MDBBtn onClick={toggleShow}>{buttonText}</MDBBtn>
        <MDBCollapse show={showShow}>{elements}</MDBCollapse>
      </div>
    </Col>
  );
};
